import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { concatMap, filter, takeWhile } from 'rxjs';
import { City, Country, State } from 'src/app/models/master-data.model';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared-service.service';

@Component({
  selector: 'app-hospital-filters',
  templateUrl: './hospital-filters.component.html',
  styleUrls: ['./hospital-filters.component.scss']
})
export class HospitalFiltersComponent {
  @Input() data: any[] = [];
  @Output() filteredData = new EventEmitter<any[]>(); 
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  entityTypes: string[] = ['Doctors', 'Hospitals', 'Labs', 'Clinics'];
  selectedEntityType: string = 'Doctors'; 
  doctor: string = '';
  hospital: string = '';
  lab: string = '';
  clinic: string = '';
  dataObj : any [] = [];
  filteredObj : any [] = [];
  isSugestionOpen: boolean = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  searchSuggestions: any[] = []; 
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  searchSuggestionList: any[] = [];
  showNoRecordsFounds: boolean = true;
  filterObject: any;
  countries!: any[];
  states!: any[];
  cities!: any[];
  brands!: any[];
  specializations!: any[];
  selectedHealth: string = '';
  yearInMarkets!: any[];
  dropDownSpecializations: any;
  paramsSearch: string = '';
  currentPage: any =1; 
  debounceTimer: any;

  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  specializationControl = new FormControl();
 
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  filteredSpecialization: any[] | undefined;
  textFromUniversalSearch:string = '';

  filterForm: FormGroup = new FormGroup({
    keywords: new FormControl(null),
    countries: new FormControl([]),
    states: new FormControl(null),
    cities: new FormControl(null),
    zipCode: new FormControl(null),
    yearFrom: new FormControl(0),
    yearTo: new FormControl(0),
    amountFrom: new FormControl(0),
    amountTo: new FormControl(0),
    specializations: new FormControl(null),
  });

  filterControls = ['keywords', 'countries', 'states', 'cities', 'zipCode', 'yearInMarkets', 'amountFrom', 'amountTo', 'specializations'];
  id:any;
  constructor(
    private readonly masterDataService: MasterDataService,
    private oemService : OemService,
    private categoryService: CategoryService,
    private readonly endCustomerService: EndCustomerService,
    private router: Router,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = localStorage.getItem('userId');
    window.addEventListener('scroll', this.scrollEvent, true); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.dataObj = changes['data'].currentValue;
      const storageKey = `${this.selectedHealth}_filters`;
      const savedFilters = sessionStorage.getItem(storageKey);
      if (savedFilters) {
        const filterState = JSON.parse(savedFilters);
        this.setFormValues(filterState);
        if (filterState.countries && filterState.countries.length > 0) {
          this.loadStates(filterState.countries);
        }
        if (filterState.states && filterState.states.length > 0) {
          this.loadCities(filterState.states);
        }
        if (filterState.specializations && filterState.specializations.length > 0) {
          this.checkedSpecialization = [...filterState.specializations];
        }
        setTimeout(() => {
          if (this.countries && this.states && this.cities && this.specializations) {
            this.applyFilter();
          }
        }, 100);
      }
    }
  }


  ngOnInit(): void {
    const isPageRefresh = this.router.getCurrentNavigation()?.id ===1;  
    if (isPageRefresh) {
      const storageKey = `${this.selectedHealth}_filters`;
      sessionStorage.removeItem(storageKey);
      this.resetFilters();
    }
    this.resetFilters();
  
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.paramsSearch = params.get('search') || '';
      this.textFromUniversalSearch = this.paramsSearch;
      this.searchSuggestion(this.paramsSearch);
      this.paramsSearch = '';
  
      if (!isPageRefresh) {
        this.loadSavedFilters();
      }
    });
  
    this.selectedHealthtype();
    this.filterForm.valueChanges.subscribe(() => {
      this.applyFilter();
      this.saveFiltersToStorage();
    });
  
    this.getAccountTypes();
    this.loadCountries('');
    this.loadStates('');
    this.loadCities('');
    this.loadBrands();
    this.loadcategories();
  
    this.countryControl.valueChanges.subscribe(value => {
      if (!value?.countryName) {
        this.filteredCountries = this.countries.filter(country =>
          country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.stateControl.valueChanges.subscribe(value => {
      if (!value?.stateName) {
        this.filteredStates = this.states.filter(state =>
          state.stateName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.cityControl.valueChanges.subscribe(value => {
      if (!value?.cityName) {
        this.filteredCities = this.cities.filter(city =>
          city.cityName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
  
    this.specializationControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredSpecialization = this.specializations.filter(specialization =>
          specialization.name.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
  }

  saveFiltersToStorage(): void {
    const filterState = this.filterForm.value;
    const storageKey = `${this.selectedHealth}_filters`;
    sessionStorage.setItem(storageKey, JSON.stringify(filterState));
    this.updateUrlWithFilters(filterState);
  }

 
  updateUrlWithFilters(filterState: any): void {
    const queryParams: any = {};
  
   this.currentPage = sessionStorage.getItem("currentPage");
    queryParams.page = this.currentPage;
  
    if (filterState.keywords && filterState.keywords.length > 0) {
      queryParams.keywords = filterState.keywords.join(',');
    }
    if (filterState.countries && filterState.countries.length > 0) {
      queryParams.countries = filterState.countries.join(',');
    }
    if (filterState.states && filterState.states.length > 0) {
      queryParams.states = filterState.states.join(',');
    }
    if (filterState.cities && filterState.cities.length > 0) {
      queryParams.cities = filterState.cities.join(',');
    }
    if (filterState.zipCode) {
      queryParams.zipCode = filterState.zipCode;
    }
    if (filterState.yearFrom > 0) {
      queryParams.yearFrom = filterState.yearFrom;
    }
    if (filterState.yearTo > 0) {
      queryParams.yearTo = filterState.yearTo;
    }
    if (filterState.specializations && filterState.specializations.length > 0) {
      queryParams.specializations = filterState.specializations.join(',');
    }
  
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true 
    });
  }

  loadSavedFilters(): void {
    const storageKey = `${this.selectedHealth}_filters`;
    let filterState: any = null;
  
    const params = this.activatedRoute.snapshot.queryParams;
    if (this.hasFilterParams(params)) {
      filterState = this.extractFiltersFromParams(params);
      sessionStorage.setItem(storageKey, JSON.stringify(filterState));
    } else {
      const savedFilters = sessionStorage.getItem(storageKey);
      if (savedFilters) {
        filterState = JSON.parse(savedFilters);
      }
    }  

    if (filterState) {
      this.setFormValues(filterState);  
      if (filterState.countries && filterState.countries.length > 0) {
        this.loadStates(filterState.countries);
      }
      if (filterState.states && filterState.states.length > 0) {
        this.loadCities(filterState.states);
      }
  
      if (filterState.specializations && filterState.specializations.length > 0) {
        this.checkedSpecialization = [...filterState.specializations];
      }
  
      const applyFilterWhenReady = () => {
        if (this.countries && this.states && this.cities && this.specializations && this.dataObj.length > 0) {
          this.applyFilter();
        } else {
          const subscription = this.filterForm.valueChanges.subscribe(() => {
            if (this.countries && this.states && this.cities && this.specializations && this.dataObj.length > 0) {
              this.applyFilter();
              subscription.unsubscribe();
            }
          });
        }
      };
  
      if (this.dataObj.length > 0) {
        applyFilterWhenReady();
      }      
    } else {
      this.filteredData.emit(this.dataObj);
    }
  }

  private hasFilterParams(params: any): boolean {
    return !!(params.keywords || params.countries || params.states || 
              params.cities || params.zipCode || params.yearFrom || 
              params.yearTo || params.specializations);
  }

  private extractFiltersFromParams(params: any): any {
    const filterState: any = {
      keywords: params.keywords ? params.keywords.split(',') : null,
      countries: params.countries ? params.countries.split(',') : null,
      states: params.states ? params.states.split(',') : null,
      cities: params.cities ? params.cities.split(',') : null,
      zipCode: params.zipCode || null,
      yearFrom: params.yearFrom ? Number(params.yearFrom) : 0,
      yearTo: params.yearTo ? Number(params.yearTo) : 0,
      amountFrom: 0,
      amountTo: 0,
      specializations: params.specializations ? params.specializations.split(',') : null,
    };
    return filterState;
  }

  private setFormValues(filterState: any): void {
    Object.keys(filterState).forEach(key => {
      if (filterState[key] !== null && filterState[key] !== undefined) {
        this.filterForm.get(key)?.setValue(filterState[key]);
      }
    });
  }

  selectedHealthtype() {
    const url = this.router.url;
    if(url.includes('doctors')) {
      this.selectedHealth = 'Doctor';
    } else if(url.includes('hospitals')) {
      this.selectedHealth = 'Hospital';
    } else if(url.includes('labs')) {
      this.selectedHealth = 'Laboratory';
    } else if(url.includes('clinics')) {
      this.selectedHealth = 'Clinics';
    }
  }

  applyFilter(): void {
   
    if (!this.countries || !this.states || !this.cities || !this.specializations) {      
      return;
    }
  
    const currentYear = new Date().getFullYear();
    let filtered = this.dataObj;
    const { keywords, countries, states, cities, zipCode, yearFrom, yearTo, specializations } = this.filterForm.value;
  
    
    if (keywords && keywords.length > 0) {
  
      const lowerCaseKeywords = keywords.map((keyword: string) => keyword.toLowerCase());
      filtered = filtered.filter(item =>
        
        (item.name && lowerCaseKeywords.some((keyword: any) => item.name.toLowerCase().includes(keyword))) ||
        (item.organization && lowerCaseKeywords.some((keyword: any) => item.organization.toLowerCase().includes(keyword))) ||
        (item.organization && lowerCaseKeywords.some((keyword: any) => item.name.toLowerCase().includes(keyword))) ||
        (item.country && lowerCaseKeywords.some((keyword: any) => item.country.toLowerCase().includes(keyword))) ||
        (item.state && lowerCaseKeywords.some((keyword: any) => item.state.toLowerCase().includes(keyword))) ||
        (item.city && lowerCaseKeywords.some((keyword: any) => item.city.toLowerCase().includes(keyword)))||
        (item?.specialityName && item?.specialityName.some((speciality: string) => 
          lowerCaseKeywords?.some((keyword: string) => speciality?.toLowerCase().includes(keyword))))      
      );
    }
    
    if (countries && countries.length > 0) {
      filtered = filtered.filter(item =>
        item.country && countries.some((country: string) => item.country.toLowerCase() === country.toLowerCase())
      );
      this.loadStates(countries);
    }

    if (states && states.length > 0) {
      filtered = filtered.filter(item =>
        item.state && states.some((state: string) => item.state.toLowerCase() === state.toLowerCase())
      );
      this.loadCities(states);
    }

    if (cities && cities.length > 0) {
      filtered = filtered.filter(item =>
        item.city && cities.some((city: string) => item.city.toLowerCase() === city.toLowerCase())
      );
    }

    if (zipCode && zipCode.length > 0) {
      filtered = filtered.filter(item => 
        item.zipCode && String(item.zipCode) === String(zipCode));
    }
    if (yearFrom >= 0 && yearTo > yearFrom) {
      filtered = filtered.filter(item => {
        if (yearFrom === 0 && item.expertSince === null) {
          return true;
        }
        if (item.expertSince !== null) {
          const yearsInMarket = currentYear - item.expertSince;
          return yearsInMarket >= yearFrom && yearsInMarket <= yearTo;
        }
        else{
          return false;
        }
      });
    }
    if(yearFrom==yearTo && yearFrom > 0){
      filtered = filtered.filter(item => {
        if (item.expertSince !== null) {
          const yearsInMarket = currentYear - item.expertSince;
          return yearsInMarket === yearFrom;
        }
        else{
          return false;
        }
      })
    }

    if (specializations && specializations.length > 0) {
      filtered = filtered.filter(item => 
        item?.specialityName && 
        item.specialityName.some((speciality: string) => 
          specializations.includes(speciality)
        )
      );
    }
    
    if (!keywords  && !states && !cities && !zipCode && yearFrom === 0 && yearTo === 0 && !countries && !specializations) {
      filtered = this.dataObj;
    }

    this.filteredData.emit(filtered);   
  }

  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement;
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
        if (autoComplete.panelOpen) {
            const panelElement = autoComplete.autocomplete.panel;
            return panelElement && panelElement.nativeElement.contains(target);
        }
        return false; 
    });
    if (!isScrollingInsidePanel) {
        this.closeAllPanels();
    }
}

closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
        if (autoComplete.panelOpen) {
            autoComplete.closePanel();
        }
    });
}


  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; 
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
        this.filteredCountries = allCountries;
      });
  }

  loadStates(countryName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allStates: any[] = [];
    let morePages = true;

    this.masterDataService.getStates(pageNumber, pageSize, '', [countryName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; // No more items to fetch
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', [countryName]);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }

  loadCities(stateName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allCities: any[] = [];
    let morePages = true;

    this.masterDataService.getCities(pageNumber, pageSize, '', [stateName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; // No more items to fetch
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', [stateName]);
        })
      )
      .subscribe(data => {
        allCities = allCities.concat(data.data);
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }

  loadBrands() {
    this.oemService.getBrandsList().subscribe({
      next: (response) => {
        this.brands = response.data; 
        this.yearInMarkets = [...new Set(response.data
          .map((item: { year: any; }) => item.year)
          .filter((year: any) => year != null && year !== '' && year !== 0)
      )];
         
      },
      error: (error) => {
       
      }
    });
  }

 
  loadcategories() {
    this.categoryService.getSpecialities().subscribe(data => {
      if (data && data.data && data.data.length > 0) {
        this.specializations = data.data;
        if(!this.filteredSpecialization) {
          this.filteredSpecialization = data.data;
        }
        this.dropDownSpecializations = data.data;
      }
    }, error => {
     
    }); 
  }

resetFilters(): void {
  this.filterForm.reset({
    keywords: null,
    countries: [],
    states: null,
    cities: null,
    zipCode: null,
    yearFrom: 0,
    yearTo: 0,
    amountFrom: 0,
    amountTo: 0,
    specializations: null
  });
  this.checkedSpecialization = [];

  const storageKey = `${this.selectedHealth}_filters`;
  sessionStorage.removeItem(storageKey);

  const searchParam = this.activatedRoute.snapshot.queryParams['search'] || null;
  const queryParams: any = {};
  
  if (searchParam) {
    queryParams.search = searchParam;
  }
  
  queryParams.page = this.currentPage;
  
  this.router.navigate([], {
    relativeTo: this.activatedRoute,
    queryParams: queryParams,
    replaceUrl: true 
  });
  sessionStorage.removeItem("Doctors_filters");
  sessionStorage.removeItem("currentPage");
   const temp= sessionStorage.setItem("currentPage","1");
   if(this.currentPage===0){
     this.currentPage=1
   }else{
    this.currentPage = temp;
   }

  this.filteredData.emit(this.dataObj);
}
 
  remove(controlName: string, item: string | number): void {
    const control = this.filterForm.get(controlName);
    if (control) {
      const currentValues = control.value || [];
      const index = currentValues.indexOf(item);
      if (index >= 0) {
        currentValues.splice(index, 1);
        control.setValue(currentValues);
      }
      
      if(this.checkedSpecialization.includes(item)) {
        const index = this.checkedSpecialization.indexOf(item);
        if (index >= 0) {
          this.checkedSpecialization.splice(index, 1);
        }
      }
      this.applyFilter();
    }
  } 

  onOptionSelected(event: any, filterType: string): void {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'continent':
      case 'country':
        currentValues = this.filterForm.get('countries')?.value || [];
        if (!currentValues.includes(event.option.value.countryName)) {
          this.filterForm.get('countries')?.setValue([...currentValues, event.option.value.countryName]);
          this.loadStates(event.option.value.countryName);
        }
        this.countryControl.reset();
        break;
  
      case 'state':
        currentValues = this.filterForm.get('states')?.value || [];
        if (!currentValues.includes(event.option.value.stateName)) {
          this.filterForm.get('states')?.setValue([...currentValues, event.option.value.stateName]);
          this.loadCities(event.option.value.stateName);
        }
        this.stateControl.reset();
        break;
  
      case 'city':
        currentValues = this.filterForm.get('cities')?.value || [];
        if (!currentValues.includes(event.option.value.cityName)) {
          this.filterForm.get('cities')?.setValue([...currentValues, event.option.value.cityName]);
        }
        this.cityControl.reset();
        break;
  
      case 'specialization':
        currentValues = this.filterForm.get('specializations')?.value || [];
        if (!currentValues.includes(event.option.value.name)) {
          this.filterForm.get('specializations')?.setValue([...currentValues, event.option.value.name]);
          this.checkedSpecialization.push(event.option.value.name);
        }
        this.specializationControl.reset();
        break;
  
      default:
        break;
    }
  
    setTimeout(() => {
      if (this.countries && this.states && this.cities && this.specializations) {
        this.applyFilter();
      } else {
        const subscription = this.filterForm.valueChanges.subscribe(() => {
          if (this.countries && this.states && this.cities && this.specializations) {
            this.applyFilter();
            subscription.unsubscribe();
          }
        });
      }
    }, 100);
  }

  showSpecialization(event: any) {
    // if()
    this.dropDownSpecializations = this.specializations.filter((obj:any)=>{return obj.name.toLowerCase().includes(event.target.value.toLowerCase());});
    
  }
  checkedSpecialization: any = [];

  onSpecializationChange(event: any, val: string) {
    
    const selectedSpecializations = this.filterForm.get('specializations')?.value || [];
    if (event.checked) {
      if (!selectedSpecializations.includes(val)) {
        this.filterForm.get('specializations')?.setValue([...selectedSpecializations, val]);
        this.checkedSpecialization.push(val);
      }
    } else {
      const index = selectedSpecializations.indexOf(val);
      if (index >= 0) {
        selectedSpecializations.splice(index, 1);
        this.filterForm.get('specializations')?.setValue(selectedSpecializations);
        const index2 = this.checkedSpecialization.indexOf(val);
        if (index2 >= 0) {
          this.checkedSpecialization.splice(index2, 1);
        }
      }
    }
  }

accountTypeId!: string;
getAccountTypes() {
  this.masterDataService.getOnboardingAllAccountTypes().subscribe((res)=>{
    res.data.map((data :any)=>{
      if(data.name === this.selectedHealth){
        this.accountTypeId = data.id;
      }
    })
  })
}


add(controlName: string, event: any): void {
  const value = event?.value?.trim() || event?.name || (typeof controlName === 'string' ? controlName.trim() : '');

  if (value) {
    const currentValues = this.filterForm.get(controlName)?.value || [];
    if (!currentValues.includes(value)) {
      this.filterForm.get(controlName)?.setValue([...currentValues, value]);
    }
  }

  this.searchSuggestions = [];
  this.isSugestionOpen = false;

  const input = event?.input || document.querySelector('input[placeholder="Search By Keyword"]');
  if (input) {
    input.value = '';
  }
}

searchSuggestionDebouncer(event: any) {
  clearTimeout(this.debounceTimer);
  this.debounceTimer = setTimeout(() =>
    this.searchSuggestion(event), 450);
}

searchSuggestion(event: any): void {
  const query = this.paramsSearch || event?.target?.value?.trim() || ''; 
  this.isSugestionOpen = query.length > 0;
  if (query) {
    this.endCustomerService.searchSuggestions(this.accountTypeId, query).subscribe(
      (response: any) => {
        this.searchSuggestions = response.data || [];  
        this.isSugestionOpen=this.searchSuggestions.length > 0;
      },
      (error: any) => {
        this.searchSuggestions = [];  
      }
    );
  } else {
    this.searchSuggestions = [];  
    this.isSugestionOpen = false;
  }
}


selectedSuggestion(suggestion: any): void {
  if (suggestion?.name) {
    this.add('keywords', { value: suggestion.name });
    const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.searchSuggestions = [];
    this.isSugestionOpen = false;
  }
}
} 